import styled from '@emotion/styled'
import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { OverviewMetricsByTime } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { contextMinusOneWeek } from '~/modules/analytics/utils'
import { Context } from '~/state'
import { WithClassName } from '~/types/utils'
import { PureOverviewTimeline } from './PureOverviewTimeline'

type OverviewTimelineProps = WithClassName & {
  context: Context
  dimensions: Dimension[]
  currencySymbol: CurrencySymbol
}
const BaseOverviewTimeline: FunctionComponent<OverviewTimelineProps> = ({ className, context, dimensions, currencySymbol }) => {
  const analyticsQueryTime = useAnalyticsQueryTanstack<OverviewMetricsByTime>('overview.metrics.by.time', dimensions, context, {})
  const analyticsQueryTimeComparison = useAnalyticsQueryTanstack<OverviewMetricsByTime>('overview.metrics.by.time', dimensions, contextMinusOneWeek(context), {})
  const timelineEmptyData: OverviewMetricsByTime = { epoch: [] }

  const onMetricChange = (_metric: string) => {}

  return (
    <PureOverviewTimeline
      className={className}
      isLoading={analyticsQueryTime.isFetching || analyticsQueryTimeComparison.isFetching}
      error={analyticsQueryTime.isError && analyticsQueryTimeComparison.isError}
      empty={!analyticsQueryTime.isFetching && !analyticsQueryTimeComparison.isFetching && !analyticsQueryTime.data?.epoch?.length}
      onRefreshClick={() => {
        analyticsQueryTime.refetch()
        analyticsQueryTimeComparison.refetch()
      }}
      data={analyticsQueryTime.data ?? timelineEmptyData}
      comparisonData={analyticsQueryTimeComparison.data ?? timelineEmptyData}
      currencySymbol={currencySymbol}
      currentEpoch={DateTime.now()}
      onMetricChange={onMetricChange}
      timezone={context.timeRange.tz}
    />
  )
}

export const OverviewTimeline = styled(BaseOverviewTimeline)``
